import Enum from 'cg-enum'
export const searchSiftEnum = new Enum(
  ['mtype', 'grades', 'subjects', 'terms', 'difficulties', 'timeTypes', 'timeSlots'],
  1
)

export const searchSiftName = {
  [searchSiftEnum.grades]: '年级',
  [searchSiftEnum.subjects]: '学科',
  [searchSiftEnum.terms]: '学期',
  [searchSiftEnum.difficulties]: '难度',
  [searchSiftEnum.timeTypes]: '时间',
  [searchSiftEnum.timeSlots]: '时段'
}

export const searchBreadName = {
  [searchSiftEnum.grades]: '年级',
  [searchSiftEnum.subjects]: '学科',
  [searchSiftEnum.terms]: '学期',
  [searchSiftEnum.difficulties]: '课程难度',
  [searchSiftEnum.timeTypes]: '上课时间',
  [searchSiftEnum.timeSlots]: '时段'
}



// WEBPACK FOOTER //
// ./src/views/AddPurchase/defines/index.js